/**
 * Step cuts — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_named_haircuts`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const stepCutsPack: ToilePack = {
    slug: 'step-cuts',
    category: 'beauty',
    name: 'Step cuts',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'long', label: 'Long step', subject: 'long straight hair cut in visible steps down the back'},
        {key: 'medium', label: 'Medium step', subject: 'medium hair with two clear steps and a centre part'},
        {key: 'bangs', label: 'Step with bangs', subject: 'a step cut with side bangs framing the face'},
    ],
    styles: [
        {key: 'salon', label: 'Salon', style: 'photographed in a bright hair salon by soft broad window daylight from camera-left, a light and open balance with few dark tones', palette: 'warm white walls and pale wood, the hair the darkest tone', framing: 'three-quarter view at eye level, waist-up, the salon mirror soft behind'},
        {key: 'back', label: 'Back view', style: 'turned three-quarters away with the head looking back over one shoulder, soft daylight from camera-right along the length of the hair, a light balance with soft shadow between the steps', palette: 'plain cream wall, the hair the darkest tone', framing: 'framed from the crown to the ends of the hair at eye level'},
        {key: 'park', label: 'Park', style: 'outdoors in a park in soft overcast light from above, an even balance with gentle shadow under the chin', palette: 'fresh greens and pale gravel', framing: 'waist-up at eye level, trees soft behind'},
    ],
    directions: ['mahogany brown', 'wavy hair', 'for thin hair'],
    directionHint: 'try: mahogany brown',
    seo: {
        title: 'Step Cuts: Long, Medium, With Bangs',
        metaDescription: 'Nine pictures of the step cut, distinct tiers of length: a long, a medium and a step cut with bangs, seen in a salon, from behind and in a park.',
        h1: 'Step cuts: long, medium, with bangs',
        tagline: 'Nine pictures, three step cuts, each in a salon, from behind and in a park.',
        intro: 'A step cut has distinct tiers of length, one above the other. These pictures show long straight hair cut in visible steps down the back, medium hair with two clear steps and a centre part, and a step cut with side bangs framing the face. One picture turns the head back over the shoulder, because the back view shows the tiers most clearly. You can type a change, such as mahogany brown, to ask for the cut with it.',
        useCases: [
            'a reference for the tiers of length',
            'choosing a long, medium or step cut with bangs',
            'a salon wall print',
            'a profile picture',
        ],
        faq: [
            {q: 'Why is one picture seen from behind?', a: 'The back view shows the tiers of length most clearly.'},
            {q: 'What do the side bangs add?', a: 'They frame the face, on top of the steps in the length.'},
            {q: 'Can I change the colour?', a: 'Yes. Type the change and the picture is made with it. It is a request, so the result may differ from the sample.'},
        ],
    },
}
